<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses"/>

    <vs-popup :active.sync="activeNotify" class="notify-package">
            <div class="vx-row">
                <div class="w-full expired">
                    <span class="">Hết hạn</span>
                </div>
                <div class="w-full" style="text-align:center">
                    <div class="component mt-4 mb-2">
                        <span class="text-expired ">Gói dữ liệu đã hết hạn</span>
                    </div>
                    <div class="component" v-for="(content, indexContent) in textNotifies" :key="indexContent">
                        <span class="text-content">{{content.text}}</span>
                    </div>
                    <vs-button class="mt-8" @click="userRegisterPackage">
                        Gia hạn
                    </vs-button>
                </div>
                <div class="w-full mt-6 close-popup cursor-pointer notify-cancel">
                    <div class="w-full" @click="canceNotify">
                        <span>Bỏ qua thông báo này</span>
                    </div>
                </div>
            </div>
        </vs-popup>
      <!-- <first-login :firstLogin="checkFirstLogin"></first-login> -->
  </div>
</template>

<script>
  import themeConfig from '@/../themeConfig.js';
  import firstLogin from './views/v2/pages/login/FirstLogin.vue'
  export default {
    components:{
      firstLogin
    },
    data() {
      return {
        checkFirstLogin: false,
        countDays:null,
        activeNotify: false,
        textNotifies:[
            {text: 'Hãy gia hạn để tiếp tục theo dõi dữ liệu mới.'},
            {text: 'Bạn vẫn có thể xem lại dữ liệu đã tổng hợp từ ngày hết'},
            {text: 'hạn trờ về trước.'},
            {text: 'Để theo dõi dữ liệu mới, hãy gia hạn gói ngay.'}
        ],
        checkedRegisterPackage:false,
        vueAppClasses: [],
        businessPackage:{}
      }
    },
    watch: {
      '$store.state.theme'(val) {
        this.toggleClassInBody(val)
      },
      '$vs.rtl'(val) {
        document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
      }
    },
    methods: {
      backToPackageManage(){
        this.$router.push('/user/package/manage').catch(() => {});
      },
      checkRegisterPackage: function(){
        return new Promise((resolve) => {
        this.$business.get('user-package/user-all-register-package').then((res) => {
            const result = res.data.filter(el => el.status == 0);
            if(result.length > 0){
            return this.$vs.dialog({
                type: 'confirm',
                color: 'primary',
                title: this.$t('packageUpgrade.titlePackage'),
                accept: this.backToPackageManage,
                text: `${this.$t('packageUpgrade.text1')} ` + ` ${result[0].businessPackage.name} ` + ` ${this.$t('packageUpgrade.text2')}` ,
                acceptText: this.$t('packageUpgrade.acceptText'),
                cancelText: this.$t('packageUpgrade.cancelText'),
            })
            }
            resolve();
        })
        })
      },
      userRegisterPackage() {
        let id = this.businessPackage.id;
        this.activeNotify = false;
        this.checkRegisterPackage().then(() => {
        this.$business.post('/user-package/register', {packageId: id}).then(() => {
            this.$vs.dialog({
                type: 'confirm',
                color: 'primary',
                title: this.$t('packageUpgrade.titleSuccess'),
                accept: this.backToPackageManage,
                text: this.$t('packageUpgrade.text5'),
                acceptText: this.$t('packageUpgrade.acceptText'),
                cancelText: this.$t('packageUpgrade.cancelText'),
            })
        }).catch((err) => {
            this.$vs.loading.close();
            return this.$vs.notify({
            text: err.response.message || err.response.error_description || err.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
            });
        });
        });
      },
      countDateRange: function(fromDate, toDate){
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const firstDate = new Date(fromDate);
        const secondDate = new Date(toDate);
        const diffDays = Math.round(((firstDate - secondDate) / oneDay));
        this.countDays = diffDays;
      },
      canceNotify: function(){
        this.activeNotify = false;
      },
      confirmRegisterPackage() {
        this.$vs.notify({
          color: 'success',
          text: 'Bạn đang chưa sử dụng gói dịch vụ nào !',
          icon:'icon-alert',
          iconPack: 'feather'
        })
      },
      toggleClassInBody(className) {
        if (className === 'dark') {
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
          document.body.classList.add('theme-dark')
        } else if (className === 'semi-dark') {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
          document.body.classList.add('theme-semi-dark')
        } else {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        }
      },
      setAppClasses(classesStr) {
        this.vueAppClasses.push(classesStr)
      },
      handleWindowResize() {
        this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

        // Set --vh property
        document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
      },
      handleScroll() {
        this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
      },    
      getRole(role) {
        switch (role) {
          case 'ROLE_ADMIN': return 'admin';
          case 'ROLE_ADMIN_ORGANIZATION': return 'organization';
          case 'ROLE_USER': return 'organization';
          case 'ROLE_CONTRIBUTOR': return 'contributor';
          default: return 'user';
        }
      },
      redirectToHomePage(userRole) {
        let href = window.location.href
        if ((href.includes('register')|| href.includes('request-demo') || href.includes('login') || href.includes('forgot-password') || href.includes('create-new-account')) && userRole === 'organization' || userRole == 'user') {
            return this.$router.replace({name: "dashboard"})
        }
        if ((href.includes('register')|| href.includes('request-demo') || href.includes('login') || href.includes('forgot-password') || href.includes('create-new-account')) && userRole === 'admin') {
          return this.$router.replace('/admin/newspaper/manage');
        }
        if ((href.includes('register')|| href.includes('request-demo') || href.includes('login') || href.includes('forgot-password') || href.includes('create-new-account')) && userRole === 'contributor') {
          return this.$router.replace('/contributor/manage-user');
        }
      },
      checkUserHasLoggedIn () {
        let token = localStorage.getItem('access_token');
        if (!token) {
          let href = window.location.href;
          if (!(href.includes('register')|| href.includes('request-demo') || href.includes('login') || href.includes('forgot-password') || href.includes('active') || href.includes('create-new-account'))) {
            this.$router.push('/pages/login')
          }
          return
        }
        // this.$business.post('user-package/using-package').then((res) => {
        //   let result = res.data;
        //   this.businessPackage = result.businessPackage;
        //   this.$root.businessPackage = result.businessPackage;
        //   let now = new Date();
        //   this.countDateRange(result.expiredDate, now)
        //   if(this.countDays <= 0){
        //       setTimeout(() => {
        //         this.activeNotify = true;
        //       }, 2000);
        //   }
        //   const permission = res.data.businessPackage.permissions;
        //   permission.forEach(el => {
        //     if(el.functionApiPrefix == '/dashboard'){
        //       this.checkedRegisterPackage = true;
        //     }
        //   });

        //     if(!this.checkedRegisterPackage){
        //       this.confirmRegisterPackage();
        //     } else {
        //       this.checkScreenPermission();
        //     }
        //   })
        let that = this;
        this.$oauth.get('/user/current').then((response) => {
          let userInfo = response.data;
          if (!userInfo) {
            return this.$router.push('/pages/login')
          }
          if (!userInfo.firstLogin || userInfo.firstLogin == 0){
            this.checkFirstLogin = true;
          } 
          userInfo.userRole = this.getRole(userInfo.roles[0].role);
          this.$acl.change(userInfo.userRole)
          that.$store.dispatch('updateUserInfo', userInfo);
          return this.redirectToHomePage(userInfo.userRole);

        }).catch(() => {
          localStorage.clear();
          return this.$router.push('/pages/login').catch(() => {
          });
        });
        if (this.$messaging) {
          this.$messaging
            .requestPermission()
            .then( () => {
              return this.$messaging.getToken()
            })
            .then((token) => {
              localStorage.setItem("deviceToken", token)
              this.$processor.post('/warning-message/subscribe', {tokens: [token]}).then(() => {
                this.$vs.loading.close();
              }).catch(() => {
                this.$vs.loading.close();
              });
              this.$business.post('/notification/subscribe',{tokens: [token]}).then(() =>{
                this.$vs.loading.close();
              }).catch(() =>{
                this.$vs.loading.close();
              });
            })
            .catch(function (err) {
              console.log("Unable to get permission to notify.", err);
          });
          this.$messaging.onTokenRefresh(() => {
            this.$messaging.getToken().then((refreshedToken) => {
              localStorage.setItem("deviceToken", refreshedToken)
              this.$processor.post('/warning-message/subscribe', {tokens: [refreshedToken]}).then(() => {
                this.$vs.loading.close();
              }).catch(() => {
                this.$vs.loading.close();
              });
              this.$business.post('/notification/subscribe', {tokens:[refreshedToken]}).then(() =>{
                this.$vs.loading.close();
              }).catch(() =>{this.$vs.loading.close()})
            }).catch(() => {
            });
          });
        }
      },
      checkScreenPermission () {
        this.$business.post('/permission/all').then((response) => {
          let permissionList = response.data.map(item => item.functionScreenPrefix);
          this.$root.permissionList = response.data;
          let packagePermission = this.businessPackage.permissions.map(item => item.functionScreenPrefix);
          this.$vs.loading.close();
          this.$router.beforeEach((to, from, next) => {
            if (this.checkNotHavePermission(to.fullPath.split("/").pop().split("?")[0], permissionList, packagePermission)) {
              return this.$vs.notify({
                text: this.$t('noPermission'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            }
            next()
          })
          let currentScreenPath = window.location.href.split("/").pop().split("?")[0];
          if (this.checkNotHavePermission(currentScreenPath, permissionList, packagePermission)) {
            this.$vs.notify({
              text: this.$t('noPermission'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
            this.$router.push(`/dashboard`)
          }
        })
      },
      checkNotHavePermission (screenPath, permissionList, packagePermission) {
        return permissionList.find(item => item.split(";").includes(screenPath.split("/").pop())) && !packagePermission.find(itemPermission => itemPermission.split(";").includes(screenPath.split("/").pop()))
      }

    },
    mounted() {
      document.getElementsByClassName('vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null')[0].style.display = 'none'
      document.getElementsByClassName('vs-popup--header')[0].style.display = 'none'
      this.$eventBus.$on('login-success', () => {
        this.checkUserHasLoggedIn();
      })
      this.toggleClassInBody(themeConfig.theme);
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    created() {
      let dir = this.$vs.rtl ? "rtl" : "ltr";
      document.documentElement.setAttribute("dir", dir);
      window.addEventListener('resize', this.handleWindowResize);
      window.addEventListener('scroll', this.handleScroll);
      this.checkUserHasLoggedIn();

    },
    destroyed() {
      window.removeEventListener('resize', this.handleWindowResize);
      window.removeEventListener('scroll', this.handleScroll)
    },
  }

</script>
<style lang="scss">
.notify-package .vs-popup {
    width: 400px !important;
    height: 322px;
}
.notify-package .vs-popup .vs-popup--content{
    width: calc(100% - 0px) !important
}
.expired {
    text-align:center;
    border-bottom:1px solid #ccc;
    height:35px
}
.close-popup {
    text-align:center;
    border-top:1px solid #ccc;
    line-height:49px
}
.notify-cancel :hover {
    background-color: #2F80ED;
    color:#fff
}
.text-content {
    font-size: 14px;
    color: #95939e;
}
.text-expired {
    font-size: 18px;
    color: #5E5873;
}
.notify-cancel{
    font-size: 14px;
    color: #2F80ED;
}
</style>
